interface Props {
  title1?: string;
  title2?: string;
  desc?: string;
  children: any;
}

export function SectionClippath({ title1, title2, desc, children }: Props) {
  return (
    <section className='relative isolate bg-transparent px-6 py-8 sm:py-12 lg:px-8'>
      <div aria-hidden='true' className='absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl'>
        <div
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
          className=' relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-sky-400 via-sky-300 to-blue-500 opacity-40 blur-[1px] sm:left-[calc(50%-30rem)] sm:w-[72.1875rem] '
        />
      </div>
      <div className='mx-auto max-w-7xl text-center'>
        {title1 ? <h2 className='text-base/7 text-lg text-brand-secondary'>{title1}</h2> : <></>}
        <span className='mt-2 text-2xl md:text-4xl tracking-tight text-white text-center bg-brand-primary px-4 py-0 rounded-t-xl'>
          {title2}
        </span>
      </div>
      <p className='mx-auto mt-6 max-w-7xl text-pretty text-center text-lg font-medium text-brand-content sm:text-xl/8'>
        {desc}
      </p>
      {children}
    </section>
  );
}
